import VideoSlideshowSolicitation from './VideoSlideshowSolicitation';

export default VideoSlideshowSolicitation;
